type XlsxStyle = typeof import('xlsx-js-style');

let xlsxStylePromise: Promise<XlsxStyle> | undefined;

export const loadXlsxStyle = (): Promise<XlsxStyle> => {
  if (!xlsxStylePromise) {
    xlsxStylePromise = import('xlsx-js-style')
      .then((module) => (module.default ?? module) as XlsxStyle)
      .catch((error) => {
        xlsxStylePromise = undefined;
        throw error;
      });
  }

  return xlsxStylePromise;
};

export const loadXlsxStyleForExport = async (): Promise<XlsxStyle | undefined> => {
  try {
    return await loadXlsxStyle();
  } catch (error) {
    console.error('Unable to load the spreadsheet export library.', error);
    return undefined;
  }
};